/** Shared hover grammar for interactive table cells.
 *
 *  Rest is the `td`'s own `bg-surface`, row hover is the global
 *  `table-hover-styling` rule (`bg-surface-muted`), and the interactive
 *  surface hovers to that same `bg-surface-muted`.
 *
 *  These rely on the `group/cell` scope every `td` already carries, so they
 *  introduce no new group scopes. */

/** The interactive-surface tint alone, for triggers that own their layout. */
export const EDITABLE_CELL_HOVER = `transition-colors hover:bg-surface-muted`

/** Full-height trigger for a cell that is one single click target.
 *
 *  `overflow-hidden` is load-bearing: the empty-cell "+" chip expands to a verb
 *  on cell hover, and a verb wider than the column would otherwise escape the
 *  cell and paint over its border and its neighbour. Menus and popovers opened
 *  from these triggers are portaled, so clipping here never reaches them. */
export const editableCellTrigger = `flex h-full w-full cursor-pointer items-center overflow-hidden px-2 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-ring/50 ${EDITABLE_CELL_HOVER}`

/** Neutral chip surface for cells holding several independently clickable
 *  chips, each its own `group/chip` scope for the chevron. */
export const editableChipTrigger = `group/chip inline-flex h-5 shrink-0 cursor-pointer items-center gap-1 rounded border-[0.5px] border-default bg-surface px-1.5 text-label-xs hover:border-strong focus:outline-none ${EDITABLE_CELL_HOVER}`

/** The passive "+N" chip that counts the chips a cell had no room for. */
export const overflowCountChip = `tag shrink-0 cursor-default px-1.5`

/** Trailing chevron for an editable cell, shown on hover and on keyboard
 *  focus. Opacity toggle rather than `display` so the cell never reflows. */
export const cellChevronClasses = `ml-auto mr-2 h-3 w-3 shrink-0 text-minimal opacity-0 transition-opacity group-hover/cell:opacity-100 group-has-[:focus-visible]/cell:opacity-100`
